import { LocalBar } from '@mui/icons-material'

const drinkCatalogIndex = {
  icon: LocalBar,
}

export default drinkCatalogIndex
